<template>
  <v-card flat :loading="loading">
    <v-list :v-show="showChannel" dense style="max-height: 600px; overflow-y: auto;">
        <v-list-item-group>
          <v-list-item
              v-for="(channel) in channelsFiltered"
              :key="channel.name"
              :to="{ name: 'chats', params: { roomType: 'channel', roomId: channel.id }}"
              active-class="active"
              class="chat-public-channel"
              style="display: -webkit-box !important;"
          >
              <v-list-item-icon>
              <v-badge
                  color="orange"
                  :value="channel.unread"
              >
                  <span slot="badge"> {{ channel.unread }} </span>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon :color="channel.iconColor()" v-bind="attrs" v-on="on">{{ channel.icon(currentUser) }}</v-icon>
                    </template>
                    <span>{{$t('chat.publicChannel')}}</span>
                  </v-tooltip>
              </v-badge>
              </v-list-item-icon>

              <v-list-item-content style="min-width: 145px !important;">
              <v-list-item-title>
                  <span :class="channel.unread > 0 ? 'font-weight-bold' : 'font-weight-regular'">{{ channel.displayUsername }}</span>
                  <div class="font-weight-light caption"><small>{{ capitalizeFirstLetter($t('chat.members.member')) }}s: {{ channel.usersCount }}</small></div>
              </v-list-item-title>
              </v-list-item-content>

              <v-list-item-action style="margin: 0px !important;" v-if="chatsWrite" active-class="active">
              <v-menu style="z-index: 999">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        icon
                        v-on:click.prevent
                        v-bind="attrs"
                        v-on="on"
                        class="context-menu-btn-public-channel"
                    >
                        <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <v-list dense>
                    <v-list-item
                        v-for="(contextMenu, index) in channel.contextMenus(currentUser)"
                        :key="index"
                        style="display: -webkit-box !important;"
                        class="context-menu-item-public-channel"
                        @click="navChannelContextMenu(contextMenu, channel)"
                    >
                        <v-list-item-icon>
                        <v-icon :color="contextMenu.color">{{contextMenu.icon}}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>{{ capitalizeFirstLetter($t(`chat.contextMenu.${contextMenu.key}`)) }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
              </v-menu>
              </v-list-item-action>
          </v-list-item>
          <!-- Vuetify directive for infinite scroll / pagination -->
          <v-card v-intersect="infiniteScrolling"></v-card>
          <v-progress-circular
            style="margin: 0px !important;min-width: 185px !important;"
            v-show="loading"
            indeterminate
            color="primary"
          ></v-progress-circular>
        </v-list-item-group>
    </v-list>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import MixinChatHelper from '@/mixins/chat/helper'
import MixinChatRoomActions from '@/mixins/chat/room_actions'

export default {
  name: 'chat-nav_channels_list',
  mixins: [MixinChatHelper, MixinChatRoomActions],
  created () {
    this.getChannels()
  },
  computed: {
    ...mapGetters({
      currentUser: 'chat/authenticatedRocketChatUser',
      channels: 'chat/channels',
      loading: 'chat/channelsLoading',
      chatsWrite: 'permissions/chatsWrite',
      paginationChannels: 'chat/paginationChannels',
      channelsLoaded: 'chat/channelsLoaded',
      filterClosed: 'chat/ChannelsFilters/closed',
      filterRead: 'chat/ChannelsFilters/read',
      searchText: 'chat/ChannelsFilters/search'
    }),
    channelsFiltered: function () {
      let filteredList = this.channels
      // Filter by open / close
      filteredList = filteredList.filter(channelConversation => {
        if (this.filterClosed) {
          return channelConversation.isCurrentUserParticipating(this.currentUser) && !channelConversation.isHidden()
        } else {
          return true
        }
      })
      // Filter by unread
      filteredList = filteredList.filter(channelConversation => {
        if (this.filterRead) {
          return channelConversation?.unread > 0
        } else {
          return true
        }
      })
      // Filter by search
      filteredList = filteredList.filter(channelConversation => {
        if (this.searchText) {
          return channelConversation.displayUsername.match(this.searchText)
        } else {
          return true
        }
      })
      return filteredList
    },
    showChannel: function () {
      return this.channels?.length > 0
    }
  },
  methods: {
    ...mapActions({
      getChannels: 'chat/getChannels',
      getMoreChannels: 'chat/getMoreChannels'
    }),
    async infiniteScrolling (entries, observer, isIntersecting) {
      if (isIntersecting && entries.length === 1 && this.channels?.length > 1 && !this.channelsLoaded) {
        await this.getMoreDirectMessages()
      }
    }
  }
}
</script>

<style scoped>
.active{
  color: #1976d2;
}
</style>
